import { apiClient } from './client';
import { Programme } from '../types/projects';

export const programmesApi = {
  list: () => apiClient.get<{ data: Programme[] }>('/api/programmes'),
  get: (id: number) => apiClient.get<{ data: Programme }>(`/api/programmes/${id}`),
  create: (input: { name: string; donorId?: number | null; managerId?: number | null }) =>
    apiClient.post<{ data: { id: number; programme_reference: string } }>('/api/programmes', input),
  update: (id: number, input: { name: string; donorId?: number | null; managerId?: number | null }) =>
    apiClient.put<{ data: Programme }>(`/api/programmes/${id}`, input),
  delete: (id: number) => apiClient.delete<{ data: { id: number; deleted: boolean } }>(`/api/programmes/${id}`),
  submit: (id: number) => apiClient.post<{ data: { id: number; status: string } }>(`/api/programmes/${id}/submit`),
  returnForRedraft: (id: number, comment: string) => apiClient.post<{ data: { id: number; status: string } }>(`/api/programmes/${id}/return`, { comment }),
  decide: (id: number, input: { decision: 'approved' | 'rejected'; comment?: string }) =>
    apiClient.post<{ data: { id: number; status: string } }>(`/api/programmes/${id}/decide`, input),
};
